module.exports = "/_next/static/images/17ea5cc8a06c05d99b2e6edd7654751f-minus.svg";